import { Inject, Injectable } from '@angular/core';
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwEventService, 
         DwCacheService, DwQueryFilter, DwQueryHelper, DwOrmData } from '@devwareapps/devware-cap';
import { Observable, defer, BehaviorSubject } from 'rxjs';
import { map, concatMap, tap } from 'rxjs/operators';
import { AppMetaDataService, EthosWachterDepartmentEntity } from '../../../meta-data/app-meta-data.service';
import { CodeValuePermitType, PermitsV2MetaDataService } from '../../permits/meta-data/permitsv2-meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class EnhancedUtilsService {

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwEventsService: DwEventService,
    private dwCacheService: DwCacheService,
  ) { }

  public chain<T>(func1 : (args : any[]) => Observable<any>, 
    ...chainFuncs : ((data : any[]) => Observable<any>)[]) : (args) => Observable<T> { 
    return (args : any[]) : Observable<T> => {
      const results : any[] = args;
      return chainFuncs.reduce((ch, next) => { return ch.pipe(concatMap((resp) => {
                                                  results.push(resp);
                                                  return next(results)
                                                })); },
                                                func1(args)).pipe(map(i => i as T));
    }
  }
}
